/**
 * Portable Appliance Testing (PAT) - Schema
 * IET Code of Practice for In-Service Inspection and Testing of Electrical Equipment
 */

const APPLIANCE_CLASSES = ['Class I', 'Class II', 'Class III'];
const TEST_RESULTS = ['PASS', 'FAIL', 'NOT TESTED'];
const RETEST_PERIODS = ['6', '12', '24', '36', '48', '60'];

export default {
  sections: [
    {
      id: 'jobDetails',
      title: 'Test Details',
      fields: [
        { id: 'certificateNumber', type: 'text', label: 'Certificate / Register Number', required: true },
        { id: 'testDate', type: 'date', label: 'Date of Testing', required: true },
        { id: 'dutyHolder', type: 'text', label: 'Duty Holder / Client Name', required: true },
        { id: 'testLocation', type: 'textarea', label: 'Test Location / Site Address', required: true },
        { id: 'companyName', type: 'text', label: 'Testing Company', required: true },
        { id: 'engineerName', type: 'text', label: 'Engineer / Technician Name', required: true },
        { id: 'engineerCardNumber', type: 'text', label: 'Engineer Card / License Number', required: true }
      ]
    },
    {
      id: 'testEquipment',
      title: 'Test Equipment Used',
      repeatable: true,
      fields: [
        { id: 'equipmentMake', type: 'text', label: 'Equipment Make' },
        { id: 'equipmentModel', type: 'text', label: 'Equipment Model' },
        { id: 'equipmentSerial', type: 'text', label: 'Serial Number', required: true },
        { id: 'calibrationDate', type: 'date', label: 'Calibration / Verification Date' },
        { id: 'calibrationDue', type: 'date', label: 'Calibration Due Date' }
      ]
    },
    {
      id: 'appliances',
      title: 'Appliance Test Register',
      repeatable: true,
      maxRowsPerPage: 30,
      fields: [
        { id: 'itemId', type: 'text', label: 'Item ID / Asset No.' },
        { id: 'description', type: 'text', label: 'Item Description', required: true },
        { id: 'applianceClass', type: 'select', label: 'Appliance Class', options: APPLIANCE_CLASSES, required: true },
        { id: 'visualInspection', type: 'select', label: 'Visual Inspection', options: ['Pass', 'Fail'], required: true },
        { id: 'earthContinuity', type: 'number', label: 'Earth Continuity (Ω)', step: 0.01 },
        { id: 'leadResistance', type: 'number', label: 'Lead Resistance (Ω)', step: 0.01 },
        { id: 'insulationResistance', type: 'number', label: 'Insulation Resistance (MΩ)', step: 0.01 },
        { id: 'touchLeakage', type: 'number', label: 'Touch / Leakage Current (mA)', step: 0.01 },
        { id: 'testResult', type: 'select', label: 'Overall Result', options: TEST_RESULTS, required: true },
        { id: 'retestPeriod', type: 'select', label: 'Retest Period (months)', options: RETEST_PERIODS },
        { id: 'notes', type: 'textarea', label: 'Notes / Defect Details' }
      ]
    },
    {
      id: 'declaration',
      title: 'Declaration',
      fields: [
        { id: 'engineerSignature', type: 'signature', label: 'Engineer Signature' },
        { id: 'customerSignature', type: 'signature', label: 'Duty Holder / Customer Signature' }
      ]
    }
  ]
};